export default __webpack_public_path__ + "static/media/21.da6c8fd2.jpg";